import { DEFAULT_FIELD_NAMES, GroupSearchFieldNamesType } from "./interface";

/**
 * 过滤对象空值
 * @param groupValue 值
 * @param fieldNames 字段映射
 */
export function filterEmptyFieldGroupSearchValue(fieldGroupValue?: any, fieldNames?: GroupSearchFieldNamesType): any {
  if (!fieldGroupValue) return undefined;
  const newFieldGroupValue: any = {};
  const typeName = fieldNames?.type || DEFAULT_FIELD_NAMES.type;
  const fieldName = fieldNames?.field || DEFAULT_FIELD_NAMES.field;
  const ruleName = fieldNames?.rule || DEFAULT_FIELD_NAMES.rule;
  const valueName = fieldNames?.value || DEFAULT_FIELD_NAMES.value;
  const value = fieldGroupValue[valueName];
  if (fieldGroupValue[typeName]) newFieldGroupValue[typeName] = fieldGroupValue[typeName];
  if (fieldGroupValue[fieldName]) newFieldGroupValue[fieldName] = fieldGroupValue[fieldName];
  if (fieldGroupValue[ruleName]) newFieldGroupValue[ruleName] = fieldGroupValue[ruleName];
  if (Array.isArray(value) && value.length) {
    newFieldGroupValue[valueName] = value;
  }
  const keys = Object.keys(newFieldGroupValue);
  return (Array.isArray(keys) && keys.length) ? newFieldGroupValue : undefined;
}